import { CSSProperties, ReactNode, useId } from 'react';
import { createPortal } from 'react-dom';

import './Popover.css';

type PopoverPosition = 'top' | 'bottom' | 'left' | 'right';

interface PopoverProps {
	children: ReactNode;
	triggerContent: ReactNode;
	buttonClassName?: string;
	popoverClassName?: string;
	position?: PopoverPosition;
}

export default function Popover({
	children,
	triggerContent,
	buttonClassName = '',
	popoverClassName = '',
	position = 'bottom'
}: PopoverProps) {
	const popoverId = useId();
	const uniqueAnchorName = `--popover-anchor-${popoverId.replace(/:/g, '')}`;

	const trigger = (
		<button
			type="button"
			popoverTarget={popoverId}
			className={`anchor-button ${buttonClassName}`}
			style={{ anchorName: uniqueAnchorName } as CSSProperties}
		>
			{triggerContent}
		</button>
	);
	const content = (
		<div
			id={popoverId}
			popover="auto"
			className={`popover ${popoverClassName}`}
			data-position={position}
			style={{ positionAnchor: uniqueAnchorName } as CSSProperties}
		>
			{children}
		</div>
	);

	return (
		<>
			{trigger}
			{createPortal(content, document.body)}
		</>
	);
}
